export default __webpack_public_path__ + "media/Monitoring.29a24250bbde00195196babbdbc81fa9.svg";